<section class="legal">
  <header class="legal__head">
    <h1>Privacy Policy</h1>
    <p class="legal__sub">
      Information regarding the processing of personal data under the GDPR.
    </p>
  </header>

  <div class="legal__card">
    <h2>1. Controller</h2>
    <p>
      <strong>noHEROES GmbH</strong><br />
      Myllendonker Straße 284<br />
      41065 Mönchengladbach<br />
      Germany<br />
      Email: <a href="mailto:support@noheroestcg.de">support&#64;noheroestcg.de</a>
    </p>

    <h2>2. Scope of this policy</h2>
    <p>
      This privacy policy applies to the website “Card Portal” and its features,
      in particular the submission of name, email address and file uploads.
    </p>

    <h2>3. Processed data</h2>
    <ul>
      <li>Name (as provided by the user)</li>
      <li>Email address</li>
      <li>Uploaded files (e.g. spreadsheet files), including file name, size and type</li>
      <li>Technical data (e.g. IP address, timestamp, user agent) stored in server logs</li>
    </ul>

    <h2>4. Purpose and legal basis</h2>
    <p>
      <strong>Submission handling and communication:</strong><br />
      Art. 6(1)(b) GDPR (performance of a contract or pre-contractual measures)
      or Art. 6(1)(f) GDPR (legitimate interest in efficient processing and support).
    </p>

    <p>
      <strong>Sending confirmation emails:</strong><br />
      Art. 6(1)(b) GDPR.
    </p>

    <p>
      <strong>Technical operation and security:</strong><br />
      Art. 6(1)(f) GDPR (legitimate interest in secure and reliable operation).
    </p>

    <h2>5. Recipients and processors</h2>
    <p>
      We may use service providers (e.g. hosting or infrastructure providers)
      acting as data processors pursuant to Art. 28 GDPR.
    </p>
    <p>
      Emails are sent via an SMTP email provider. In this context, email addresses,
      message content and technical metadata are processed.
    </p>

    <h2>6. File uploads</h2>
    <p>
      Uploaded files are processed exclusively for the purpose of handling your submission.
      Please do not upload files containing unnecessary sensitive personal data.
    </p>

    <h2>7. Data retention</h2>
    <p>
      Personal data is stored only for as long as necessary to fulfil the stated purposes
      or as required by statutory retention obligations. Log data is typically stored
      for a limited period for operational and security reasons.
    </p>

    <h2>8. Cookies and tracking</h2>
    <p>
      This website does not use tracking technologies for cross-site user profiling.
      Technically necessary cookies may be used depending on the hosting platform
      (e.g. for security or basic functionality).
    </p>

    <h2>9. Your rights</h2>
    <p>
      You have the right to access (Art. 15 GDPR), rectification (Art. 16),
      erasure (Art. 17), restriction of processing (Art. 18),
      data portability (Art. 20) and objection (Art. 21 GDPR).
    </p>
    <p>
      You also have the right to lodge a complaint with a supervisory authority
      (Art. 77 GDPR).
    </p>

    <h2>10. Contact</h2>
    <p>
      For privacy-related inquiries, please contact:
      <a href="mailto:support@noheroestcg.de">support&#64;noheroestcg.de</a>
    </p>

    <h2>11. Changes to this policy</h2>
    <p>
      We reserve the right to update this privacy policy if legal requirements,
      services or data processing practices change.
    </p>
  </div>

  <div class="legal__note">
    <p class="muted">
      Last updated: <strong>{{ today }}</strong>
    </p>
  </div>
</section>
